/**
 * @ipc/admin-ui · shared/api/token-store — хранение JWT-пары в localStorage.
 *
 * SPA-модель: браузер сам шлёт Bearer (в отличие от прежней httpOnly-cookie схемы).
 * accessToken (TTL ~15 мин) — в каждом запросе; refreshToken (TTL 30 дней sliding,
 * rotation на каждом POST /admin/auth/refresh) — для обмена при 401 / proactive.
 * Хранение в localStorage — сознательный выбор служебной панели за VPN/периметром.
 */

const ACCESS_KEY = 'ipc-access-token';
const REFRESH_KEY = 'ipc-refresh-token';

export function getAccessToken(): string | null {
  try {
    return localStorage.getItem(ACCESS_KEY);
  } catch {
    return null;
  }
}

export function getRefreshToken(): string | null {
  try {
    return localStorage.getItem(REFRESH_KEY);
  } catch {
    return null;
  }
}

export function setTokens(accessToken: string, refreshToken?: string): void {
  try {
    localStorage.setItem(ACCESS_KEY, accessToken);
    if (refreshToken !== undefined) {
      localStorage.setItem(REFRESH_KEY, refreshToken);
    }
  } catch {
    // localStorage недоступен — сессия проживёт до перезагрузки страницы.
  }
}

export function clearTokens(): void {
  try {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  } catch {
    // no-op
  }
}
